import { gql } from "@apollo/client";

const UPDATE_DOCUMENT = gql`
  mutation UpdateDocument($documentId: ID!, $args: UpdateDocumentInput) {
    updateDocument(documentId: $documentId, args: $args) {
      _id
      fileCategory
      fileName
      executionDate
    }
  }
`;

const REQUEST_AGREEMENT = gql`
  mutation RequestAgreement($args: CreateDocumentInput!) {
    requestAgreement(args: $args) {
      _id
    }
  }
`;

const DELETE_DOCUMENT = gql`
  mutation DeleteDocument($documentId: ID!) {
    deleteDocument(documentId: $documentId) {
      _id
      createdAt
      fileCategory
      fileName
    }
  }
`;
export { UPDATE_DOCUMENT, REQUEST_AGREEMENT, DELETE_DOCUMENT };
